export const vanLessons = [
  {
    id: 'van-1',
    title: 'Phân tích bài thơ Việt Bắc - Tố Hữu',
    slug: 'phan-tich-bai-tho-viet-bac',
    grade: 12,
    subject: 'Văn học',
    views: 12450,
    readTime: 15,
    excerpt: 'Phân tích toàn diện bài thơ Việt Bắc của Tố Hữu - tác phẩm ca ngợi tình cảm chiến đấu và khát vọng hòa bình.',
    category: 'Văn học hiện đại'
  },
  {
    id: 'van-2',
    title: 'Nghị luận xã hội - Cách viết bài văn nghị luận',
    slug: 'nghi-luan-xa-hoi',
    grade: 11,
    subject: 'Văn học',
    views: 18900,
    readTime: 20,
    excerpt: 'Hướng dẫn chi tiết cách viết bài văn nghị luận xã hội với cấu trúc rõ ràng, dẫn chứng phong phú.',
    category: 'Kỹ năng viết'
  },
  {
    id: 'van-3',
    title: 'Chiếc lược ngà - Phân tích tác phẩm',
    slug: 'chiec-luoc-nga',
    grade: 10,
    subject: 'Văn học',
    views: 15600,
    readTime: 18,
    excerpt: 'Phân tích truyện ngắn Chiếc lược ngà của Nguyễn Quang Sáng với những giá trị nhân văn sâu sắc.',
    category: 'Truyện ngắn'
  },
  {
    id: 'van-4',
    title: 'Tác phẩm Chữ người tử tù - Nguyễn Tuân',
    slug: 'chu-nguoi-tu-tu',
    grade: 9,
    subject: 'Văn học',
    views: 14200,
    readTime: 12,
    excerpt: 'Phân tích tác phẩm Chữ người tử tù - bài văn mẫu về lòng yêu nước và tinh thần bất굴.',
    category: 'Văn học hiện đại'
  },
  {
    id: 'van-5',
    title: 'Cách làm bài văn tả người',
    slug: 'cach-lam-bai-van-ta-nguoi',
    grade: 8,
    subject: 'Văn học',
    views: 22000,
    readTime: 10,
    excerpt: 'Hướng dẫn chi tiết cách miêu tả chân dung người với kỹ thuật tả ngoại hình và tâm hồn.',
    category: 'Kỹ năng viết'
  },
  {
    id: 'van-6',
    title: 'Đoạn trích Ông già và biển cả',
    slug: 'ong-gia-va-bien-ca',
    grade: 7,
    subject: 'Văn học',
    views: 16800,
    readTime: 14,
    excerpt: 'Phân tích đoạn trích Ông già và biển cả của Hemingway - bài học về ý chí và nghị lực.',
    category: 'Văn học nước ngoài'
  }
];
